import { Tab, Tabs, Icon } from "@blueprintjs/core"
import React, { useState } from "react"
import CustomDialog from "components/Atoms/CustomDialog"
import SelectedMessage from "./SelectedMessage"
import UpdateStatus from "./UpdateStatus"
import { useSelector, useDispatch } from "react-redux"
import { TOGGLE_BULK_UPDATE_MODAL } from "store/all-vehicles/all-vehicles.actions"
import UpdateDepartments from "./UpdateDepartments"

export default function UpdateVehicleDialog() {
  const isOpen = useSelector(state => state.allVehicles.isBulkUpdateModalOpen)
  const dispatch = useDispatch()
  const [tab, setTab] = useState("status")
  //   const isOpen = useSelector(state=>state.v)
  return (
    <CustomDialog
      light
      title={
        <>
          <Tabs selectedTabId={tab} onChange={tab => setTab(tab)}>
            <Tab
              id="status"
              title={
                <span>
                  <Icon iconSize={14} icon="clean" />
                  <span>Status</span>
                </span>
              }
            />
            <Tab
              id="departments"
              title={
                <span>
                  <Icon iconSize={14} icon="briefcase" />
                  <span>Departments</span>
                </span>
              }
            />
          </Tabs>
        </>
      }
      width="50%"
      isOpen={isOpen}
      onClose={() => {
        dispatch({
          type: TOGGLE_BULK_UPDATE_MODAL,
        })
      }}
    >
      <SelectedMessage />
      {tab === "status" ? (
        <UpdateStatus />
      ) : tab === "departments" ? (
        <UpdateDepartments />
      ) : null}
    </CustomDialog>
  )
}
